// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__esvy0","sendOtp":"AuthorizeToLogin_sendOtp__2Xlv9"};